// apps/admin-ui/src/components/sidebars/SpaceSidebar.tsx
import { NavLink, useParams } from 'react-router-dom';
import {
  FileText,
  Database,
  Navigation,
  ArrowLeftRight,
  LayoutTemplate,
  Layers,
  Settings,
  type LucideIcon,
} from 'lucide-react';
import { SpaceSwitcher } from '../cms/SpaceSwitcher.tsx';
import { sidebarItemClass, sidebarSectionLabelClass } from './sidebarStyles.ts';

interface SectionDef {
  label: string;
  items: { path: string; label: string; icon: LucideIcon }[];
}

const SECTIONS: SectionDef[] = [
  {
    label: 'Content',
    items: [
      { path: 'pages', label: 'Pages', icon: FileText },
      { path: 'collections', label: 'Collections', icon: Database },
    ],
  },
  {
    label: 'Navigation',
    items: [
      { path: 'menus', label: 'Menus', icon: Navigation },
      { path: 'redirects', label: 'Redirects', icon: ArrowLeftRight },
    ],
  },
  {
    label: 'Design',
    items: [
      { path: 'layouts', label: 'Layouts', icon: LayoutTemplate },
      { path: 'collection-templates', label: 'Collection Templates', icon: Layers },
    ],
  },
];

export function SpaceSidebar() {
  const { spaceId } = useParams<{ spaceId: string }>();

  if (!spaceId) return null;

  return (
    <nav className="flex flex-col py-2 gap-0">
      <SpaceSwitcher />

      {SECTIONS.map((sec) => (
        <div key={sec.label}>
          <span className={sidebarSectionLabelClass}>{sec.label}</span>
          <div className="px-2 flex flex-col gap-0.5">
            {sec.items.map(({ path, label, icon: Icon }) => (
              <NavLink
                key={path}
                to={`/spaces/${spaceId}/${path}`}
                className={({ isActive }) => sidebarItemClass(isActive)}
              >
                <Icon size={14} className="shrink-0" />
                {label}
              </NavLink>
            ))}
          </div>
        </div>
      ))}

      <div className="mt-4 pt-2 mx-2 border-t border-zinc-100">
        <NavLink
          to={`/spaces/${spaceId}/settings`}
          className={({ isActive }) => sidebarItemClass(isActive)}
        >
          <Settings size={14} className="shrink-0" /> Settings
        </NavLink>
      </div>

    </nav>
  );
}
